import { css, styled } from 'styled-components'
import { m } from 'motion/react'
import { ReactComponent as ShippingBoxIcon } from 'icons/assets/ShippingBox.svg'

// Solid halo matching the surface behind the bar, masking the track around each
// chip to create the gaps in the line. Overridden per variant on BarRow.
const MARKER_HALO_COLOR = 'var(--discount-marker-halo, #fcf4f7)'
const MARKER_BORDER_COLOR = 'var(--discount-marker-border, #fcf2f5)'

export const Chip = styled(m.div)<{ $reached: boolean; $isIcon: boolean }>`
  position: relative;
  order: ${({ $reached }) => ($reached ? 0 : 2)};
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 24px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.0083em;
  white-space: nowrap;
  background-color: var(
    --discount-marker-bg,
    ${({ theme }) => theme.colors.white}
  );
  color: ${({ theme }) => theme.colors.secondaryDark};
  border: 2px solid ${MARKER_BORDER_COLOR};
  box-shadow: 0 0 0 3px ${MARKER_HALO_COLOR};
  min-width: 54px;
  ${({ $isIcon }) =>
    $isIcon &&
    css`
      min-width: auto;
    `}
  transition:
    background-color 0.32s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.32s cubic-bezier(0.4, 0, 0.2, 1),
    border-color 0.32s cubic-bezier(0.4, 0, 0.2, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  ${({ $reached, theme }) =>
    $reached &&
    css`
      background-color: ${theme.colors.primary};
      color: ${theme.colors.white};
      border-color: ${theme.colors.primary};
    `}
`

export const ChipContent = styled(m.span)`
  display: inline-flex;
  align-items: center;
`

export const ShippingBox = styled(ShippingBoxIcon)`
  width: 14px;
  height: 13px;
`
